<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-market-select
            v-model="filter.marketId"
            init-value
            :clearable="false"
            width="130px"
        ></gj-market-select>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'asin', text: 'ASIN'},
              {id: 'msku', text: 'MSKU'},
              {id: 'title', text: '商品标题'},
            ]">
        </gj-select-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="数据时间"
            :max-day-length="180"
            :clearable="false"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-checkbox
          v-model="filter.filterAdZero"
          @input="$gjNoticeQuery">
        <span style="color: #666">过滤广告业绩为0的数据</span>
      </gj-checkbox>
    </template>
    <template #tool-group>
      <gj-tool-group
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="asinAdAnalysis"
          :loading="loading"
          size="has-picture"
          :data="tableData"
          :columns="columns"
          expand
          show-summary
          :expand-lazy-load="expandLazyLoad"
          :pagination="pagination"
          :show-overflow="false"
          :expandTableAttrs="{ 'span-method': spanMethod }"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:picture="{row}">
          <gj-image :src="row.imageUrl"></gj-image>
        </template>
        <template v-slot:listingInfo="{row}">
          <div>
            <gj-tooltip
                :text-line="1"
                :content="row.title"
                class="listing-title">
              {{row.title | defaultShow}}
            </gj-tooltip>
          </div>
          <el-row style="margin: 2px 0;">
            <el-col :span="12">
              <span class="gj-table--label">ASIN：</span>
              <span class="asin-value">
                    <gj-link :href="row.asinAmazonUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  </span>
            </el-col>
            <el-col :span="12">
              <span class="gj-table--label">父ASIN：</span>
              <span class="variationAsin-value">{{row.variationAsin | defaultShow}}</span>
            </el-col>
          </el-row>
          <div>
            <span class="gj-table--label">MSKU：</span>
            <span class="msku-value">{{ row.msku | defaultShow }}</span>
          </div>
        </template>
        <template v-slot:analysis="{row}">
          <gj-button
              type="text"
              @click="analysis(row)"
              style="font-size: 21px;">
            <gj-icon iconfont="iconshuju1"></gj-icon>
          </gj-button>
        </template>
        <template v-slot:expand:picture="{row}">
          <div v-gutter="8">
            <app-ad-route-link
                :market-id="row.marketId"
                :type="row.adsType === 0 ? AdTypeEnum.SP : AdTypeEnum.SB"
                :campaign="row">
              {{row.campaignName}}
            </app-ad-route-link>
            <span>[ {{ row.adsType === 0 ? '商品广告' : '展示广告' }} ]</span>
            <span >&gt;</span>
            <app-ad-route-link
                :market-id="row.marketId"
                :type="row.adsType === 0 ? AdTypeEnum.SP : AdTypeEnum.SB"
                :campaign="row"
                :group="row"
                :group-targeting-type="row.groupTargetingType">
              {{row.groupName}}
            </app-ad-route-link>
            <span :style="{color: row.servingStatus === 'OUTOFBUDGET' || row.servingStatus === 'OUT_OF_BUDGET' || row.servingStatus === 'CAMPAIGN_OUT_OF_BUDGET' ? 'red' : ''}">
              [ {{row.servingStatus | optionText([...AdCampaignEnum.SP.servingStatusOption, ...AdCampaignEnum.SB.servingStatusOption]) | defaultShow('', '', '广告活动已暂停')}} ]
            </span>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../common/fields";
  import AppAdAsinAnalysisModal from "./modal/ad-asin-analysis-modal";
  import {subDays} from 'date-fns';
  import {queryMixin} from "../../../../../minxins";
  import {convertToDate} from "../../../../../utils/date.util";
  import {getAdsAsinPerformanceMsku, getAdsAsinPerformancePage} from "../../../../../api/ad";
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {adDefaultSortMixin, adTypeRouteMixin, currencySymbolMixin} from "../../common/mixin";
  import {AdCampaignEnum} from "../../common/enum";
  import {getMarket} from "../../../../../api/common";
  import AppAdRouteLink from "../../common/components/app-ad-route-link";

  export default {
    name: "app-ad-asin-analysis",
    components: {AppAdRouteLink},
    mixins: [queryMixin, currencySymbolMixin, adTypeRouteMixin, adDefaultSortMixin],
    props: ['startDate', 'endDate'],
    data() {
      return {
        tableData: [],
        columns: [
          {...adFields.picture, field: 'slot:picture'},
          {id: 'listingInfo', header: '商品信息', field: 'slot:listingInfo', minWidth: '300px', fixed: 'left'},
          {id: 'analysis', header: '分析', field: 'slot:analysis', minWidth: '60px', fixed: 'left'},
          adFields.impressions,
          adFields.clicks,
          adFields.ctr,
          adFields.cost,
          adFields.cpc,
          adFields.orders,
          adFields.cvr,
          adFields.cpa,
          adFields.sales,
          adFields.acos,
          // adFields.acoas,
          // adFields.asoas,
          adFields.roas
        ],
        filter: {
          marketId: null,
          filterAdZero: true,
          keyword: {
            key: 'asin',
            value: null
          },
          date: [subDays(new Date(), 6), new Date()]
        },
        AdCampaignEnum: AdCampaignEnum,
        initMarketId: null,
        currencySymbol: '',
        cacheOptions: {
          useCache: true,
        }
      }
    },
    activated() {
      // 若路由中查询参数marketId/asin变化时，重新初始化查询参数
      if (this.$route.query.marketId !== this.filter.marketId || this.$route.query.asin !== this.filter.keyword.value) {
        this.$gjQueryInit();
        this.$gjNoticeQuery();
      }
    },
    watch: {
      startDate: {
        handler() {
          this.filter.date = [this.startDate, this.endDate];
          this.$gjNoticeQuery();
        }
      }
    },
    methods: {
      $gjQueryInitParams() {
        let date = this.startDate ? [this.startDate, this.endDate] : [subDays(new Date(), 6), new Date()];
        return {
          filter: {
            marketId: this.$route.query.marketId || this.filter.marketId,
            keyword: {
              key: 'asin',
              value: this.$route.query.asin || null
            },
            date,
            filterAdZero: true,
          },
        };
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{marketId: *}}
       */
      $gjCacheCallback(params) {
        return {
          marketId:  this.$route.query.marketId || params.marketId,
        };
      },
      $gjQuery() {
        if (isMeaningless(this.filter.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            marketId: this.filter.marketId,
            dataType: this.filter.filterAdZero ? 1 : 0,
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        this.globalParams = params;
        // 查询
        this.loading = true;
        getMarket(this.filter.marketId)
          .then((market) => {
            this.currencySymbol = market.currencySymbol;
            return Promise.resolve(market.currencySymbol);
          })
          .then((currencySymbol) => {
            return getAdsAsinPerformancePage(params)
              .then((data) => {
                if (isMeaningful(data)) {
                  this.tableData = this.currencySymbolMixin(data.records, currencySymbol);
                  this.pagination = this.getPagination(data);
                } else {
                  this.tableData = [];
                }
              });
          })
          .complete(() => {
            this.loading = false;
          })
      },
      expandLazyLoad(row, index, resolve) {
        getAdsAsinPerformanceMsku({
          ...this.globalParams.model,
          asin: row.asin,
        })
          .then((data) => {
            resolve(this.currencySymbolMixin(data || [], this.currencySymbol));
          })
          .catch(() => {
            resolve([]);
          });
      },
      spanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 3
          };
        } else if (columnIndex === 2 || columnIndex === 3) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      },
      analysis(row) {
        this.$gjCreate(AppAdAsinAnalysisModal, {
          props: {
            marketId: this.filter.marketId,
            currencySymbol: this.currencySymbol,
            item: row,
            queryDate: this.filter.date
          }
        });
      },
    }
  }
</script>

<style scoped>
  .listing-title {

  }
  .asin-label,
  .variationAsin-label,
  .msku-label {
    color: #333;
  }
  .asin-value,
  .variationAsin-value,
  .msku-value {
    color: #666;
  }
  /deep/ .el-rate__icon {
    margin-right: 0;
  }
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
  /deep/ .el-table__expanded-cell thead {
    display: none;
  }
  /deep/ .el-table__expanded-cell .el-table__expand-icon {
    display: none;
  }
  /deep/ .el-table__expanded-cell td {
    background: #eeeff0 !important;
  }
</style>
